<div
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  class="z-50 flex h-full w-full items-center justify-center rounded-lg bg-white p-4 dark:bg-zinc-800">
  <div
    class="flex h-full w-full items-center justify-center overflow-hidden rounded-lg border-2 border-dashed border-blue-400 p-4 dark:border-blue-500">
    <div class="relative">
      <!-- Content -->
      <div class="relative z-10 text-center">
        <div class="mb-4 hidden [@media(min-height:1000px)]:block">
          <svg
            class="mx-auto text-blue-500 dark:text-blue-400"
            fill="none"
            height="48"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
            width="48">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14,2 14,8 20,8" />
            <line x1="16" x2="8" y1="13" y2="13" />
            <line x1="16" x2="8" y1="17" y2="17" />
            <polyline points="10,9 9,9 8,9" />
          </svg>
        </div>

        <h3 class="mb-2 text-lg font-medium text-gray-900 dark:text-white">
          {{ config().displayText }}
        </h3>

        <p class="text-sm text-gray-500 dark:text-gray-400">
          {{ config().acceptedFileTypesText }}: {{ config().acceptedFileTypes.join(', ') }}
        </p>

        @if (!config().onlyCaptureFiles) {
          <div class="mt-4">
            <app-select
              [items]="config().availableTransformers"
              [value]="selectedTransformer() ?? null"
              [placeholder]="'upload_zone.select_transformer' | translate"
              (valueChange)="selectedTransformer.set($any($event) ?? undefined)" />
          </div>
        }

        @if (errorWhileUploading) {
          <p
            class="mt-2 rounded-full bg-red-50 px-2 py-1 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-400">
            {{ errorWhileUploading }}
          </p>
        }
        <div class="mt-4">
          <input
            #fileInput
            type="file"
            [multiple]="config().multiple"
            [accept]="config().acceptedFileTypes.join(',')"
            (change)="onFileInputChange($event)"
            class="hidden" />

          <div class="flex items-center gap-3">
            <button
              type="button"
              (click)="fileInput.click()"
              class="rounded-full border-0 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 dark:bg-blue-900/20 dark:text-blue-400 dark:hover:bg-blue-900/40">
              {{ 'upload_zone.choose_file' | translate }}
            </button>

            <span class="text-sm text-gray-500 dark:text-gray-400">
              {{ selectedFileName() || 'upload_zone.no_file_selected' | translate }}
            </span>
          </div>
        </div>
        @if (hasUploadButton()) {
          <div class="mt-4">
            <button
              (click)="onUpload()"
              class="btn-primary focus:border-accent-focus focus:ring-accent-focus dark:focus:border-accent-focus dark:focus:ring-accent-focus block w-full rounded-lg border border-teal-600 px-4 py-2 text-sm focus:ring-2 dark:border-teal-800 dark:placeholder-gray-400">
              {{ 'upload_zone.upload' | translate }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
